import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_MAIN_BANNER_SUCCESS,
  GET_ALL_MAIN_BANNER_REQUEST,
  GET_ALL_MAIN_BANNER_FAILURE,
  GET_ALL_SIDE_BANNER_REQUEST,
  GET_ALL_SIDE_BANNER_FAILURE,
  GET_ALL_SIDE_BANNER_SUCCESS,
} from "./ActionType";

export const getAllMainBanner = () => async (dispatch) => {
  dispatch({ type: GET_ALL_MAIN_BANNER_REQUEST });
  try {
    const { data } = await publicAxios.get(`banners/main`);
    dispatch({ type: GET_ALL_MAIN_BANNER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_MAIN_BANNER_FAILURE, payload: error.message });
  }
};

export const getAllSideBanner = () => async (dispatch) => {
  dispatch({ type: GET_ALL_SIDE_BANNER_REQUEST });
  try {
    const { data } = await publicAxios.get(`banners/side`);
    dispatch({ type: GET_ALL_SIDE_BANNER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SIDE_BANNER_FAILURE, payload: error.message });
  }
};
